import { VisibilityOn, IBasicUserType } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledEyeIcon = styled(VisibilityOn)<IBasicUserType>`
  width: ${rem('22px')};
  height: auto;
  margin-left: ${rem('8px')};

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

export const StyledButton = styled.button`
  display: flex;
  padding: 0;
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('14px')};
  font-weight: 700;
  text-transform: uppercase;
  appearance: none;
  cursor: pointer;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: none;
  }
`;

export const StyledHeader = styled.header`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const StyledTitle = styled.h4`
  margin: 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: 600;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('24px')};
    padding-bottom: ${rem('16px')};
    border-bottom: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
  }
`;

export const StyledWrapper = styled.div`
  width: 100%;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-grow: 1;
    padding-top: ${rem('40px')};
    padding-bottom: ${rem('32px')};
    border-bottom: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: column;
  }
`;
